import React from "react";

import BobaSponsorIcon_noBGC from "../../assets/images/bobasponsor.png";
import BobaSponsorIcon_noBGC_white from "../../assets/images/sponsor-logo.png";

const BobaSponsorIcon = ({ onClick }) => (
    <a
        href="https://catvv.bobaboba.me"
        target="_blank"
        rel="noreferrer"
        className="eDynhg"
        onClick={onClick}
    >
        <img
            className="animate__animated animate__bounce animate__rubberBand animate__infinite"
            src={BobaSponsorIcon_noBGC}
            alt="boba-icon"
        />
        <div className="boba-text">請我喝珍奶！</div>
    </a>
);

export default BobaSponsorIcon;
